import { Mic, Square, Loader2 } from "lucide-react";
import { useRecorder } from "@/hooks/useRecorder";

export const MicButton = ({ onText, testId, label = "Speak" }) => {
  const { state, toggle } = useRecorder(onText);
  const Icon = state === "recording" ? Square : state === "busy" ? Loader2 : Mic;
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={toggle}
      disabled={state === "busy"}
      className={`mic-btn ${state === "recording" ? "mic-live" : ""}`}
      aria-label={label}
    >
      <Icon className={`h-5 w-5 ${state === "busy" ? "animate-spin" : ""}`} />
      <span>{state === "recording" ? "Stop" : state === "busy" ? "Listening…" : label}</span>
    </button>
  );
};
